import React, { useState, useEffect } from 'react';
import format from 'date-fns/format';
import { Helmet } from 'react-helmet';
import { getEntryByContentType } from 'api/contentful';
import RichTextRenderer from 'components/RichTextRenderer';
import { Container, Header, Content, LeftColumn, Image } from './styled';

const Ukraine = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();

  const fetchData = async () => {
    const data = await getEntryByContentType('ukrainePage');
    setData(data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container bg="white" variant="dark" isLoading={isLoading}>
      <Header>
        <h1>{data?.fields?.pageTitle}</h1>
        {data?.sys?.updatedAt && (
          <div>
            Last updated on{' '}
            <b>{format(new Date(data?.sys?.updatedAt), 'MMMM dd, yyyy')}</b>
          </div>
        )}
      </Header>
      <Content>
        <LeftColumn>
          <RichTextRenderer richText={data?.fields?.content} />
        </LeftColumn>
        {data?.fields?.image?.fields.file.url && (
          <Image src={data?.fields?.image?.fields.file.url} alt="image" />
        )}
      </Content>
      <Helmet>
        <title>Useful resources for Ukraine</title>
        <meta
          name="description"
          content="Useful resources for Ukrainan refugees, visa options and border crossings"
        />
        <link rel="canonical" href="https://safetywing.com/ukraine" />
      </Helmet>
    </Container>
  );
};

export default Ukraine;
